module.exports = __webpack_public_path__ + "static/badgeProc-90403053c6e12000270784779f95278c.png";